import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

// Ecran afișat când utilizatorul anulează plata din Stripe Checkout.
export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div
      data-testid="payment-cancel-page"
      className="min-h-screen flex flex-col items-center justify-center px-6 text-center"
    >
      <XCircle className="h-16 w-16 text-slate-300" strokeWidth={2} />
      <h1 className="font-heading text-2xl font-black mt-4" style={{ color: "#0f1b2d" }}>
        Plata a fost anulată
      </h1>
      <p className="text-sm text-slate-500 mt-1">
        Nu s-a reținut nicio sumă. Poți încerca din nou oricând.
      </p>
      <button
        data-testid="payment-cancel-back-btn"
        onClick={() => navigate("/premium")}
        className="mt-6 w-full max-w-xs py-3.5 rounded-2xl font-bold text-white active:scale-95 transition-transform"
        style={{ backgroundColor: "#12b981" }}
      >
        Înapoi la Premium
      </button>
    </div>
  );
}
